import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { MensajesPersonalizados } from 'src/app/interfaces/mensajePersonalizadoData';
import { LoginService } from 'src/app/service/login.service';
import { MensajesService } from 'src/app/service/message.service';

@Component({
  selector: 'app-mensaje-personalizado-grupo',
  templateUrl: './mensaje-personalizado-grupo.component.html',
  styleUrls: ['./mensaje-personalizado-grupo.component.scss'],
  providers: [MessageService]
})
export class MensajePersonalizadoGrupoComponent implements OnInit{
  deviceUrl: string = '';
  deviceName: string = '';

  camposMensaje: MensajesPersonalizados = {
    idCustomer: 0,
    token: '',
    nombreCampania: '',
    mensaje: '',
    verificarNumeros: 'No'
  };

  validar: boolean = false;

  archivoSeleccionado: File | null = null;

  importacionCsvSeleccionada: boolean = false;

  constructor(private mensajesServicio: MensajesService, private messageService: MessageService, private route: ActivatedRoute,
    private loginService: LoginService, private router: Router, private translate: TranslateService){
      // Establecer idiomas disponibles y el idioma por defecto
      translate.addLangs(['en', 'es']);
      translate.setDefaultLang('es');
    }

    ngOnInit(): void {
      this.route.queryParams.subscribe(params => {
        const token = params['deviceUrl'] || '';
        const nombre = params['deviceName'] || '';
        if (token) {
          this.deviceUrl = token;
        } 
        if(nombre){
          this.deviceName = nombre;
        }
      });
      this.camposMensaje.idCustomer = this.loginService.chatCrmUser.idCustomer;
      // Obtener el parámetro 'lang' de la URL
      this.route.queryParams.subscribe(params => {
        const lang = params['lang'];
        if (lang) {
          this.translate.use(lang);
        } else {
          this.translate.use('es'); // Idioma por defecto
        }
      });          
    }

    // Método para manejar la selección de archivos
  onFileSelected(event: any) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.archivoSeleccionado = fileList[0];
    }
  }

  enviarMensaje(): void{
    if( this.camposMensaje.nombreCampania === "" || this.camposMensaje.mensaje === ""){
      this.messageService.add({severity: 'error', summary: 'Error', detail: this.translate.instant('ALERT_FIELDS')})
      this.validar = true;
      return;
    }
    if (!this.deviceUrl) {
      this.messageService.add({
        severity: 'error', 
        summary: 'Error', 
        detail: this.translate.instant('SELECT_DEVICE_ERROR')
      });
      return;
    }
    this.camposMensaje.token = this.deviceUrl;
    if (this.archivoSeleccionado) {
      console.log("Archivo seleccionado:", this.archivoSeleccionado);
      // Llama al servicio para crear la lista, pasando la nuevaLista y el archivoSeleccionado
      this.mensajesServicio.enviarMensajePersonalizado(this.camposMensaje, this.archivoSeleccionado)
      .subscribe(() => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: this.translate.instant('PERSONALIZED_MESSAGE')});
          setTimeout(()=>{this.router.navigate(['/campaigns'], {queryParams: {deviceUrl: this.deviceUrl, deviceName: this.deviceName},
          queryParamsHandling: 'merge'})},2500)
        }, () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_ERROR')});
        });
    }
  }

  regresar(deviceUrl: string, deviceName: string){
    this.router.navigate(['/campaigns'], { queryParams: { deviceUrl: this.deviceUrl, deviceName: this.deviceName },
    queryParamsHandling: 'merge' });
  }

}
